// src/components/Hero.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Hero.css';
import bannerImage from '../assets/banner1.png';

interface HeroProps {
  eyebrow?: string; // Optional short tagline shown above the title
  title: string;
  subtitle: string;
  primaryButtonText?: string;
  primaryButtonLink?: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
  smallHero?: boolean; // Added smallHero prop as optional boolean
  backgroundImage?: string; // Optional custom background image
}

const Hero: React.FC<HeroProps> = ({
  eyebrow,
  title,
  subtitle,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
  smallHero = false, // Default to false if not provided
  backgroundImage = bannerImage // Default to banner1.png
}) => {
  return (
    <section
      className={`hero ${smallHero ? 'hero-small' : ''}`}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="hero-overlay"></div>
      <div className="container hero-content">
        {eyebrow && <p className="hero-eyebrow">{eyebrow}</p>}
        <h1>{title}</h1>
        <p>{subtitle}</p>

        {(primaryButtonText || secondaryButtonText) && (
          <div className="hero-btns">
            {primaryButtonText && primaryButtonLink && (
              <Link to={primaryButtonLink} className="btn">{primaryButtonText}</Link>
            )}
            {secondaryButtonText && secondaryButtonLink && (
              <Link to={secondaryButtonLink} className="btn btn-outline">{secondaryButtonText}</Link>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default Hero;